import { faArrowUpRightFromSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import useFetch from "./ApiClient/GetApi";
import { PostApi } from "./ApiClient/PostApi";
import "./CategoryTwo.css";
import { formatDate } from "./Utils/DateFormat";

function plainSupport(htmlOrText = "", maxWords = 100) {
    if (!htmlOrText) return "";
    // Strip HTML if any
    if (/<[a-z][\s\S]*>/i.test(htmlOrText)) {
        const div = document.createElement("div");
        div.innerHTML = htmlOrText;
        div.querySelectorAll("script,style,noscript,iframe,svg").forEach((el) => el.remove());
        htmlOrText = (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
    }
    const words = htmlOrText.trim().split(/\s+/);
    return words.length <= maxWords ? htmlOrText : words.slice(0, maxWords).join(" ") + "…";
}

const CategoryTwo = (url) => {
    const navigate = useNavigate();

    const { apiData, loading: newsLoading } = useFetch(`/user/newsDetails/${url?.slug}`);
    const currentArticle = apiData?.data?.newsData;
    const relatedNews = apiData?.data?.relatedNews || [];

    // Infinite scroll state
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [moreNews, setMoreNews] = useState([]);
    const loaderRef = useRef(null);

    const cards =
        relatedNews.length > 0
            ? relatedNews.slice(0, 3).map((item) => ({
                id: item.id,
                slug: item.slug,
                image: item.thumbnail || "/placeholder.jpg",
                title: item.category?.name || "General",
                description: item.title || "Related news item",
            }))
            : [
                {
                    id: 1,
                    slug: "sample-article-1",
                    image:
                        "https://imgix.bustle.com/uploads/image/2025/8/18/c0544235/brothersheader.jpg?w=130&h=130&fit=crop&crop=faces",
                    title: "Retrospective",
                    description:
                        "HollyWood's Modern Obsession With Dark Fairy Tales Began 20 Years ago",
                },
                {
                    id: 2,
                    slug: "sample-article-2",
                    image:
                        "https://imgix.bustle.com/uploads/shutterstock/2025/8/29/786454b5/shutterstock-5873524a.jpg?w=130&h=130&fit=crop&crop=faces",
                    title: "Retrospective",
                    description: "The 'Worst' Highlander Movie Ever Would be Celebrated Today ",
                },
                {
                    id: 3,
                    slug: "sample-article-3",
                    image:
                        "https://imgix.bustle.com/uploads/image/2025/9/1/e76d5996/noc_sti-add-venice_2.jpg?w=130&h=130&fit=crop&crop=faces",
                    title: "VENICE 2025 REVIEW",
                    description: " 'No Other Choice' Is Nothing Short Of Spectacular  ",
                },
            ];

    const navigateToNews = (newsSlug) => {
        navigate(`/article/${newsSlug}`);
    };

    // Fetch more (spinner is now shown by the observer before calling this)
    const fetchMore = useCallback(async () => {
        if (!currentArticle?.id) return;
        if (loadingMore || !hasMore) return;

        try {
            const payload = {
                page,
                limit: 5,
                excludeId: currentArticle.id,
            };

            const res = await PostApi("/user/getMoreNews", payload);
            const ok = res?.data?.status === 1;
            const data = res?.data?.data || {};
            const items = Array.isArray(data.items) ? data.items : [];
            const nextHasMore = Boolean(data.hasMore);

            setMoreNews((prev) => {
                const seen = new Set(prev.map((n) => n.id));
                const incoming = items.filter(
                    (n) => n?.id && !seen.has(n.id) && n.id !== currentArticle.id
                );
                return incoming.length ? [...prev, ...incoming] : prev;
            });

            setHasMore(nextHasMore);
            if (ok && nextHasMore) setPage((p) => p + 1);
        } catch (err) {
            console.error("fetchMore error:", err);
        } finally {
            setLoadingMore(false); // hide spinner after network finishes
        }
    }, [page, hasMore, loadingMore, currentArticle?.id]);

    // IntersectionObserver: show spinner first, then fetch
    useEffect(() => {
        if (!currentArticle?.id) return;

        const el = loaderRef.current;
        if (!el) return;

        let fetching = false;

        const io = new IntersectionObserver(
            (entries) => {
                const [entry] = entries;
                if (!entry.isIntersecting) return;
                if (fetching || loadingMore || !hasMore) return;

                fetching = true;          // avoid rapid refires
                setLoadingMore(true);     // show spinner immediately

                // small delay so spinner paints before network starts (polish)
                setTimeout(async () => {
                    await fetchMore();
                    fetching = false;
                }, 250);
            },
            {
                root: null,
                rootMargin: "0px 0px 400px 0px", // start earlier so loader is visible
                threshold: 0,
            }
        );

        io.observe(el);
        return () => io.disconnect();
    }, [currentArticle?.id, hasMore, loadingMore, fetchMore]);




    const ContentBlock = () => (
        <div className="container">
            <div className="pad">
                {/* Image */}
                <div className="movie-area">
                    <img
                        className="movie-img"
                        src={currentArticle?.thumbnail}
                        alt="Movie-img"
                        loading="lazy"
                        style={{ width: "100%", aspectRatio: "16 / 9", objectFit: "cover", display: "block" }}
                    />

                    <div>
                        <div className="btn  tags updates">{currentArticle?.category?.name}</div>
                        <h1 className="heading">{currentArticle?.title}</h1>
                        <div className="plain-text-area">
                            <div className="text">{/* reserved */}</div>
                            <div className="img-content">
                                <div className="img-name">by {currentArticle?.user?.name}</div>
                                <div className="img-date">
                                    {currentArticle?.createdAt ? formatDate(currentArticle.createdAt) : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Text */}
                <div>
                    <p className="Para">{plainSupport(currentArticle?.content)}</p>
                </div>
            </div>

            <div className="pad">
                <div className="all">
                    <div className="left">
                        <div
                            className="blog-detail-main"
                            style={{ flex: 1 }}
                            dangerouslySetInnerHTML={{
                                __html: currentArticle?.content ?? "",
                            }}
                        />
                    </div>

                    {/* Sidebar */}
                    <div className="right">
                        <div className="subscribe-section">
                            <div className="subscribe-sidebar">
                                <div className="subscribe-box">
                                    <img src="/left-cruveee.png" alt="" className="svg-img" />

                                    <h3 className="newsletter-titles">LEARN SOMETHING NEW EVERY DAY </h3>
                                    <div className="Bg">
                                        <div className="formss-text">
                                            Subscribe for free to Inverse's award-winning daily newsletter!
                                        </div>
                                        <input type="email" className="email" placeholder="Enter email here" />
                                        <div className="forms-text">
                                            By subscribing to this BDG newsletter, you agree to our Terms of Service and
                                            Privacy Policy
                                        </div>
                                    </div>
                                    <div className="flex">
                                        <div className="wrapper">
                                            <img src="/curveee.png" className="text-img" alt="" />
                                            <div className="align">Submit</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="edit">{"<<<"} More like this</div>
                        <div className="card-list">
                            {cards.map((card, index) => (
                                <div className="card-container" key={index}>
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        className="card-image"
                                        loading="lazy"
                                        style={{
                                            width: "130px",
                                            height: "px",
                                            objectFit: "cover",
                                            display: "block",
                                            flexShrink: 0,
                                        }}
                                    />
                                    <div className="card-text" onClick={() => navigateToNews(card.slug)}>
                                        <span className="card-tag">{card.title}</span>
                                        <h3 className="card-description">{card.description}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    );

    const FetchedNewsBlock = ({ item }) => (
        <div className="container" key={item?.id || item?.slug}>
            <div className="pad">
                <div className="movie-area">
                    <img
                        className="movie-img"
                        src={item?.thumbnail || "/placeholder.jpg"}
                        alt={item?.title || "News thumbnail"}
                        loading="lazy"
                        style={{ width: "100%", aspectRatio: "16 / 9", objectFit: "cover", display: "block" }}
                    />
                    <div>
                        <div className="btn tags updates">{item?.category?.name || "General"}</div>
                        <h1 style={{ cursor: "pointer" }} onClick={() => navigateToNews(item?.slug)} className="heading">{item?.title || "Related News"}</h1>
                        <div className="plain-text-area">
                            <div className="img-content">
                                <div className="img-name">by {item?.user?.name || "Unknown Author"}</div>
                                <div className="img-date">
                                    {item?.createdAt ? formatDate(item.createdAt) : ""}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    {/* Short preview to avoid giant HTML walls */}
                    <div
                        className="Para"
                        dangerouslySetInnerHTML={{ __html: item?.content || "No content available" }}
                    />
                </div>
            </div>
            <div className="advertise">advetisement</div>

            <div className="pad">
                <div className="all">
                    <div className="left">
                        {/* ✅ Use the item's content here (was currentArticle before) */}
                        <div
                            className="blog-detail-main"
                            style={{ flex: 1 }}
                            dangerouslySetInnerHTML={{
                                __html: item?.content ?? "",
                            }}
                        />
                    </div>
                    {/* Sidebar */}
                    <div className="right">
                        <div className="subscribe-section">
                            <div className="subscribe-sidebar">
                                <div className="subscribe-box">
                                    <img src="/left-cruveee.png" alt="" className="svg-img" />

                                    <h3 className="newsletter-titles">LEARN SOMETHING NEW EVERY DAY </h3>
                                    <div className="Bg">
                                        <div className="formss-text">
                                            Subscribe for free to Inverse's award-winning daily newsletter!
                                        </div>
                                        <input type="email" className="email" placeholder="Enter email here" />
                                        <div className="forms-text">
                                            By subscribing to this BDG newsletter, you agree to our Terms of Service and
                                            Privacy Policy
                                        </div>
                                    </div>
                                    <div className="flex">
                                        <div className="wrapper">
                                            <img src="/curveee.png" className="text-img" alt="" />
                                            <div className="align">Submit</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="edit">{"<<<"} More like this</div>
                        <div className="card-list">
                            {cards.map((card, index) => (
                                <div className="card-container" key={index}>
                                    <img
                                        src={card.image}
                                        alt={card.title}
                                        className="card-image"
                                        loading="lazy"
                                        style={{
                                            width: "130px",
                                            height: "150px",
                                            objectFit: "cover",
                                            display: "block",
                                            flexShrink: 0,
                                        }}
                                    />
                                    <div className="card-text" onClick={() => navigateToNews(card.slug)}>
                                        <span className="card-tag">{card.title}</span>
                                        <h3 className="card-description">{card.description}</h3>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <hr />
            </div>
        </div>
    );


    if (newsLoading) {
        return (
            <div
                style={{
                    minHeight: "60vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <div
                    className="spinner"
                    style={{
                        width: 48,
                        height: 48,
                        border: "5px solid #c20a7c",
                        borderTop: "5px solid #fff",
                        borderRadius: "50%",
                        animation: "spin 1s linear infinite",
                    }}
                />
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
        );
    }
    console.log(moreNews);
    return (
        <>
            <ContentBlock />

            {/* Render fetched more news */}
            {moreNews.map((item) => (
                <FetchedNewsBlock key={item?.id || item?.slug} item={item} />
            ))}

            {/* Loader element for intersection observer */}
            <div
                ref={loaderRef}
                style={{ padding: "20px", display: "flex", justifyContent: "center", minHeight: 60 }}
            >
                {loadingMore && (
                    <div
                        className="spinner"
                        style={{
                            width: 40,
                            height: 40,
                            border: "4px solid #f3f3f3",
                            borderTop: "4px solid #c20a7c",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                        }}
                    />
                )}
                {!hasMore && moreNews.length > 0 && (
                    <div style={{ textAlign: "center", padding: "20px", color: "#666" }}>
                        No more news to load
                    </div>
                )}
                <style>{`@keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`}</style>
            </div>
        </>
    );
};

export default CategoryTwo;
